const changePassportDeniedCauseCorpVerify = {
    title: 'Ошибка сохранения',
    description:
        'Нельзя редактировать <b>паспортные данные</b>, если ваша компания <b>уже верифицирована</b>. Для изменения данных обратитесь в поддержку',
    buttonText: 'Понятно',
    mode: 'denied',
} as const;

export default changePassportDeniedCauseCorpVerify;
